import { render, staticRenderFns } from "./MatchRuleDrawer.vue?vue&type=template&id=3dbb5dad&scoped=true"
import script from "./MatchRuleDrawer.vue?vue&type=script&lang=js"
export * from "./MatchRuleDrawer.vue?vue&type=script&lang=js"
import style0 from "./MatchRuleDrawer.vue?vue&type=style&index=0&id=3dbb5dad&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dbb5dad",
  null
  
)

export default component.exports